import { AlertServiceProvider } from '../../../core/services/alert-service/alert-service';
import { Component, ViewChild } from '@angular/core';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { DisplayServiceProvider } from '../../../core/services/display-service/display-service';
import { ENVIRONMENT } from '../../../../../environments/environment';
import { FiltersService } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/filters/filters.service';
import { HttpErrorResponse } from '@angular/common/http';
import { IClientModel } from '../../../clients/interfaces/i-client-model.interface';
import { IonicPage, ModalController, NavParams } from 'ionic-angular';
import { ListConfig } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/list-config.interface';
import { ListRendererComponent } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { Observable } from 'rxjs';
import { SaveTask, TaskService } from '../../services/task.service';
import { StorageServiceProvider } from '../../../core/services/storage-service/storage-service';
import { TaskAddPage } from '../task-add/task-add';
import { TaskDetailsPage } from '../task-details/task-details';
import { TextServiceProvider } from '../../../core/services/text-service/text-service';
import { DataViewClient, DataViewClientsService } from '../../services/data-view-clients.service';
import { take } from 'rxjs/operators';

@IonicPage()
@Component({
  selector: 'page-task-list',
  templateUrl: 'task-list.html',
})
export class TaskListPage {
  @ViewChild(ListRendererComponent)
  taskList: ListRendererComponent;
  public config: ListConfig;
  public db: any;
  public loading = true;
  public engineUrl = ENVIRONMENT.engineUrl;
  public filtersConfig;
  public clientFromContext: IClientModel = null;
  public clientData: DataViewClient;
  public sortByKey: string = 'priority';
  public sortByDirection: 'ASC' | 'DESC' = 'DESC';
  public filtersLoading = false;
  private dataReceived = false;

  constructor(
    private displayService: DisplayServiceProvider,
    private filtersService: FiltersService,
    private modalCtrl: ModalController,
    private storageService: StorageServiceProvider,
    private taskService: TaskService,
    public configService: ConfigServiceProvider,
    public textService: TextServiceProvider,
    private alertService: AlertServiceProvider,
    private navParams: NavParams,
    private dataViewClientsService: DataViewClientsService,
  ) {}

  ngOnInit() {
    this.db = this.storageService.db;
    this.clientFromContext = this.navParams.get('client');
    this.config = this.displayService.getScreenComponent('representative_tasks', 'representative_tasks');
    this.filtersConfig = this.displayService.getScreenComponent('representative_tasks_filters', 'representative_tasks_filters');
  }

  ionViewDidEnter() {
    this.loading = true;
    if (this.clientFromContext) {
      this.getClientFromDataView(() => this.refreshTaskList(ENVIRONMENT.defaultDataViewTimeout));
    } else {
      this.refreshTaskList(ENVIRONMENT.defaultDataViewTimeout);
    }
  }

  private getClientFromDataView(callback: Function): void {
    this.dataViewClientsService
      .getClientFromDataViewByClientId(this.clientFromContext.clientId)
      .pipe(take(1))
      .subscribe((client) => {
        this.clientData = client;
        if (callback) {
          callback();
        }
      });
  }

  private applyContextFilter(): void {
    if (this.clientFromContext) {
      this.filtersService.applyFilters('representative_tasks', [
        {
          column: 'client_id',
          type: 'STRING',
          value: this.clientFromContext.clientId.toString(),
          queryValue: {
            column: 'client_id',
            type: 'EQUALS',
            value: this.clientFromContext.clientId.toString(),
          },
        },
      ]);
    } else {
      this.filtersService.applyFilters('representative_tasks', []);
    }
  }

  navigateTo($task: { viewId: string; element?: Object; objectKey?: Object }) {
    const modal = this.modalCtrl.create(TaskDetailsPage, {
      task: $task.element,
    });
    modal.onDidDismiss((post: Observable<Object>) => {
      if (post) {
        this.handleModifyTaskResponse(post);
      }
    });
    modal.present();
  }

  private handleModifyTaskResponse(post: Observable<Object>): void {
    this.loading = true;
    post.subscribe(
      () => this.refreshTaskList(ENVIRONMENT.defaultDataViewTimeout),
      (error) => {
        this.loading = false;
        this.handleError(error);
      },
    );
  }

  openAddTaskForm() {
    const modal = this.modalCtrl.create(TaskAddPage, {
      client: this.clientData,
    });

    modal.onDidDismiss((task) => {
      if (task) {
        this.handleAddTaskFormResponse(task);
      }
    });

    modal.present();
  }

  private handleAddTaskFormResponse(task): void {
    this.loading = true;
    const saveTask = this.mapTask(task);

    this.taskService.saveTask(saveTask).subscribe(
      () => this.refreshTaskList(ENVIRONMENT.defaultDataViewTimeout),
      (error) => {
        this.loading = false;
        this.handleError(error);
      },
    );
  }

  private mapTask(task): SaveTask {
    let mappedTask: SaveTask = {
      taskType: {
        id: task.taskType.id,
        dictionaryDefinitionId: task.taskType.dictionaryDefinitionId,
      },
      description: task.description,
      client: task.client.id,
      topic: task.topic,
      priority: {
        id: task.priority.id,
        dictionaryDefinitionId: task.priority.dictionaryDefinitionId,
      },
    };
    if (task.taskType.id === 4) {
      mappedTask.representative = task.representative.id;
    }
    return mappedTask;
  }

  private refreshTaskList(timeout: number): void {
    this.filtersLoading = true;
    setTimeout(() => {
      this.applyContextFilter();
      setTimeout(() => (this.filtersLoading = false), timeout);
    }, timeout);
  }

  public handleDataLoadingEnd(data: any) {
    const taskId = this.navParams.get('pushTaskId');
    let task;
    if (!this.dataReceived && taskId) task = data.find((task) => task.id === taskId);
    if (task) this.navigateTo({ viewId: '', element: task });
    this.extractOptionsFromData(data);
  }

  extractOptionsFromData(data: any[]) {
    if (!this.dataReceived && !this.clientFromContext && data.length > 0) {
      this.filtersService.extractOptionsFromData('representative_tasks', data);
      this.dataReceived = true;
    }
  }

  private handleError(err): void {
    console.error(err);
    if (err instanceof HttpErrorResponse) {
      if (err.status === 500 || err.status === 400) {
        this.alertService.showServiceInternalError();
      } else if (err.status === 0) {
        this.alertService.showServiceDownError();
      } else {
        this.alertService.showUnexpectedError();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/tasks/pages/task-list/task-list.ts